import axios from 'axios';
import getUrl from 'utils/getUrl';
import { generateApiError } from './utils/apiErrorMessages';
import { mapHeaderToApiModel } from './dataMapper/headerDataMapper';

export default (collectionPath, entityId, { headerId, headerImageData }) =>
  axios
    .patch(
      getUrl.apiV2(`${collectionPath}/${entityId}/items/${headerId}`),
      mapHeaderToApiModel(headerImageData),
    )
    .catch(generateApiError());
